module.exports = __webpack_public_path__ + "img/image-13.13c7541f.png";